import styled from 'styled-components'

export const StyledSaleInfoSection = styled.div`
  .full-width {
    width: 100%;
  }

  .announcements-block {
    max-width: 500px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    cursor: default;
  }

  @media (max-width: 768px) {
    .arbitration-field {
      display: flex;
    }

    .arbitration-field span {
      min-width: 120px;
    }
  }
`
